module.exports = __webpack_public_path__ + "static/media/arrow-right.32d8e988.svg";